// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"313":"1201b5df","357":"60cb1261","489":"b2b3defe","552":"e94ee963","865":"9f497b03","887":"6f8dce7c"}[chunkId] + ".css";
};